import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M10.317 4.75a2.38 2.38 0 1 0 0 4.762 2.38 2.38 0 0 0 0-4.762ZM2.875 8.006h3.404a4.132 4.132 0 0 0 8.169-.875 4.13 4.13 0 0 0-8.17-.875H2.876a.875.875 0 1 0 0 1.75Zm13.023-1.75a.875.875 0 0 0 0 1.75h5.582a.875.875 0 1 0 0-1.75h-5.582Zm2.178 11.982a4.132 4.132 0 0 1-8.169-.875 4.13 4.13 0 0 1 8.169-.875h3.404a.875.875 0 1 1 0 1.75h-3.404ZM2 17.363c0-.483.392-.875.875-.875h5.581a.875.875 0 1 1 0 1.75H2.875A.875.875 0 0 1 2 17.363Zm9.657 0a2.38 2.38 0 1 1 4.762 0 2.38 2.38 0 0 1-4.762 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFilter;
